import React from 'react';
import * as types from '../constants/action-types';
import { Sync } from '../../../../api/api-sync';
import { FormattedMessage } from 'react-intl';

const errorComponent = (<FormattedMessage id="hosting.contracts.error_message" defaultMessage="Something went wrong, please try again."/>);

const syncTypes = ({ name, status, ...response }) => {
  return {
    REQUEST: {
      type: types[name],
      calendarData: {
        isFetching: true,
        error: ''
      }
    },
    SUCCESS: {
      type: types[name],
      calendarData: {
        isFetching: false,
        error: '',
        ...response
      },
      status
    },
    FAILURE: {
      type: types[name],
      calendarData: {
        isFetching: false,
        error: errorComponent
      }
    }
  };
};

const calendarsFetchType = ({ name, calendars }) => {
  const calSyncTypes = {
    CALENDAR_SYNC_FETCH_REQUEST: {
      type: types[name],
      externalCalendars: {
        isFetching: true,
        error: ''
      }
    },
    CALENDAR_SYNC_FETCH_SUCCESS: {
      type: types[name],
      externalCalendars: {
        isFetching: false,
        calendars,
        error: ''
      }
    },
    CALENDAR_SYNC_FETCH_FAILURE: {
      type: types[name],
      externalCalendars: {
        isFetching: false,
        error: errorComponent
      }
    }
  };
  return calSyncTypes[name];
};

export const fetchSyncErrorStatus = () => (dispatch, getState) => {
  dispatch({ type: types.FETCH_SYNC_STATUS_REQUEST });
  const { auth = {} } = getState();
  return Sync.fetchSyncStatusAllCal(auth.accessToken, (response) => {
    const { sync_error_space_ids: syncErrorSpaceIds = [] } = response;
    if (200 !== response.statusCode) {
      return dispatch({ type: types.FETCH_SYNC_STATUS_FAILURE });
    }
    return dispatch({ type: types.FETCH_SYNC_STATUS_SUCCESS, syncErrorSpaceIds });
  });
};

export const fetchCronofyCalendars = (cb) => (dispatch, getState) => {
  dispatch(calendarsFetchType({ name: 'CALENDAR_SYNC_FETCH_REQUEST' }));
  const { auth = {}, calendar = {} } = getState();

  const fetchCalendarsCall = () => {
    return new Promise((resolve, reject) => {
      return Sync.fetchCronofyCalendars(calendar.selectedSpace, auth.accessToken, (response) => {
        if (200 !== response.statusCode) {
          return reject();
        }
        const { calendars = [] } = response;
        return resolve(calendars);
      });
    });
  };

  fetchCalendarsCall()
    .then((calendars) => {
      if (cb) cb(calendars);
      return dispatch(calendarsFetchType({ name: 'CALENDAR_SYNC_FETCH_SUCCESS', calendars }));
    })
    .catch(() => dispatch(calendarsFetchType({ name: 'CALENDAR_SYNC_FETCH_FAILURE' })));
};

export const fetchSyncStatusOneSpace = () => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(syncTypes({ name: 'SYNC_REQUEST' }).REQUEST);
    const { auth = {} } = getState();
    const selectedSpace = (getState().calendar || {}).selectedSpace;
    const fetchSyncStatusCall = () => {
      return new Promise((resolveCall, rejectCall) => {
        return Sync.fetchSyncStatusOneSpace(selectedSpace, auth.accessToken, (response) => {
          if (200 !== response.statusCode) {
            return rejectCall();
          }
          return resolveCall(response || {});
        });
      });
    };

    fetchSyncStatusCall()
      .then(({ obj_state: status = '', statusCode, ...response }) => {
        dispatch(syncTypes({ name: 'SYNC_SUCCESS', status, ...response }).SUCCESS);
        return resolve();
      })
      .catch(() => {
        dispatch(syncTypes({ name: 'SYNC_FAILURE' }).FAILURE);
        reject();
      });
  });
};

export const updateSyncStatus = (path) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(syncTypes({ name: 'SYNC_REQUEST' }).REQUEST);
    const { auth = {} } = getState();

    const updateSyncStatusCall = () => {
      return new Promise((resolveCall, rejectCall) => {
        return Sync.updateSync(path, auth.accessToken, (response) => {
          if (200 !== response.statusCode) {
            return rejectCall();
          }
          return resolveCall(response || {});
        });
      });
    };

    return updateSyncStatusCall()
      .then(({ obj_state: status = '', statusCode, ...response }) => {
        dispatch(syncTypes({ name: 'SYNC_SUCCESS', status, ...response }).SUCCESS);
        dispatch(fetchSyncErrorStatus());
        return resolve(response);
      })
      .catch(() => {
        dispatch(syncTypes({ name: 'SYNC_FAILURE' }).FAILURE);
        return reject();
      });
  });
};
